export const maskedText = (groups) => {

    const nodeList = [...document.querySelectorAll('.masked-line')]
    const delayFactor = 160

    if (nodeList.length) {
        groups.filter(group => [...group.querySelectorAll('.masked-line')].length).forEach( (group) => {
            const additionalDelay = parseInt( group.dataset.triggerDelay ?? 0);

            ([...group.querySelectorAll('.masked-line')]).map(line => {
                const delay = parseInt(line.offsetTop / line.offsetHeight * delayFactor)
                delay ? line.style.setProperty('--masked-line-translate-delay', `${ delay }s`) : false
            })


        })
    }
}


/*
export const maskedText = (nodeList) => {
    const delayFactor = 160
    const maskedLines = [...nodeList]

    if (maskedLines.length) {
        maskedLines.forEach( (line) => {
            const delay = parseInt(line.offsetTop / line.offsetHeight * delayFactor)
            delay ? line.style.setProperty('--masked-line-translate-delay', `${ delay }ms`) : false
        })
    }
}
*/

